export default __webpack_public_path__ + "static/media/report-bg-m.ca5aebe7.png";